import { useEffect, useMemo } from 'react';

import { TRACE_LOG_INFO_LEVEL } from '@/Pages/Graph/src/control/types';
import { foreignDataToTree } from '@/Pages/Graph/src/data/foreign-data';
import { InputEntry, NodeEntry, TraceLog } from '@/Pages/Graph/src/data/misc';

import { useTraceLogStore } from '../store/traceLogStore';

export const useSetSupportedThreadLogInfoLevels = ({
  threadGroupedByTurns,
}: {
  threadGroupedByTurns: Record<number, TraceLog[]>;
}) => {
  const toggleSupportedInfoLevel = useTraceLogStore(
    (state) => state.toggleSupportedInfoLevel
  );
  const foreignDataTrees = useMemo(() => {
    return Object.values(threadGroupedByTurns)
      .filter((thread) => thread.length)
      .map((thread) => {
        return thread
          .filter(
            ({ entry }) => entry.type === 'input' || entry.type === 'node'
          )
          .map(({ entry }) =>
            foreignDataToTree({
              data: (entry as NodeEntry | InputEntry).data,
            })
          );
      });
  }, [threadGroupedByTurns]);
  const isAllLeaves = foreignDataTrees.every((tree) =>
    tree.every((node) =>
      node?.type === 'Leaf'
        ? Array.isArray(node.value.value)
          ? node.value.value.every((v) => v.type !== 'tool')
          : true
        : false
    )
  );

  //if the data to render is a leaf then we won't have a node_expanded state
  useEffect(() => {
    toggleSupportedInfoLevel(
      TRACE_LOG_INFO_LEVEL.NODE_STATE_EXPANDED,
      !isAllLeaves
    );
  }, [isAllLeaves, toggleSupportedInfoLevel]);
};
